import { render } from "./PromiseIcon4.vue?vue&type=template&id=da61f988"
import script from "./PromiseIcon4.vue?vue&type=script&lang=js"
export * from "./PromiseIcon4.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__